import { info } from "sass-embedded";

export default {
  postdoc: {
    title: "Postdoctoral Station",
    content:
      "Shanghai Superconductor Institute provides postdoctoral positions for outstanding researchers in the field of superconducting materials and applications. We welcome talented individuals to join our team.",
    menuTitle: "Postdoctoral Station",
    accordionTitle: "Postdoctoral Station",
    accordionContent: "Explore cutting-edge superconducting technology and achieve your research dreams.",
    leftPanel: {
      title: "Why Join Us?",
      paragraph1: "We are seeking top-tier talents from around the world.",
      paragraph2:
        " At Shanghai Superconductor, we provide a platform where you can turn your dreams into reality. Here, you can fully express your individuality and unleash your passion. ",
      paragraph3: "If you are a high achiever with a relentless pursuit of your dreams, Shanghai Superconductor is where you belong.",
      paragraph4: "Email (Recruitment)：hr{'@'}shsctec.com",
    },

    jobs: {
      doc: {
        title: "Postdoctoral Researcher",
        details: `Job Responsibilities:
---Grow and control functional thin films (metals, metal oxides, etc.) using physical or chemical deposition techniques, and characterize their microstructures and physical properties.

---Requirements:
---1.Good health, strong sense of responsibility, and excellent team cooperation.

---2.Experience in operating thin-film growth equipment (e.g., electron beam evaporation, pulsed laser deposition, sol-gel methods).

---3.Understanding of thin-film epitaxy principles and experience in thin-film characterization and physical property testing.

---4.Research during Ph.D. or postdoctoral period directly related to thin-film materials is preferred.

---5.Strong written and verbal communication skills in both Chinese and English.`,
      },
    },
  },
  recruit: {
    title: "Recruitment",
    content: "We are seeking top-tier talents from around the world.",
    menuTitle: "Recruitment",
    accordionTitle: "Recruitment",
    accordionContent: "Find top talent and create a superconducting future together.",

    leftPanel: {
      title: "Why Join Us?",
      paragraph1: "We are seeking top-tier talents from around the world.",
      paragraph2:
        " At Shanghai Superconductor, we provide a platform where you can turn your dreams into reality. Here, you can fully express your individuality and unleash your passion. ",
      paragraph3: "If you are a high achiever with a relentless pursuit of your dreams, Shanghai Superconductor is where you belong.",
      paragraph4: "Email (Recruitment)：hr{'@'}shsctec.com",
    },

    jobs: {

      salesSpecialist: {
        title: "Domestic Sales",
        details: `Job Responsibilities:
---1.Bidding Work
---Independently complete bid document preparation to ensure a high success rate.
---Collaborate with the team to optimize bid content and enhance competitiveness.
---2.Customer Relationship Management
---Respond promptly to customer needs and handle emergencies.
---Provide comprehensive services to improve customer satisfaction.
---3.Internal Process Optimization
---Participate in the improvement and implementation of company policies, and offer suggestions.
---Assist with document organization, audits, and other tasks to ensure compliance.
---4.Order Execution Management
---Accurately enter order information into the ERP system and track order execution throughout the process. 
---Coordinate with various departments to ensure smooth business operations.
---5.Customer Development
---Actively seek potential customers through market research, industry exhibitions, and online platforms.
---Develop a customer development plan, regularly visit potential customers, understand their needs, and identify cooperation opportunities. Establish good communication with potential customers, introduce the company's product and service advantages, and facilitate cooperation intentions. Track the conversion of potential customers and provide timely feedback on customer development progress to support the company's business expansion.

---Qualifications:
---1.Excellent communication skills and business negotiation abilities.
---2.Ability to independently handle the sales process and solve problems effectively.
---3.Proactive and passionate about sales work.`,
      },
      testEngineer: {
        title: "Test Engineer (R&D Position)",
        details: `Job Responsibilities:
---1.Conduct comprehensive performance testing and analysis of superconducting tapes (wires), coils, and joints.
---2.Perform material performance tests and analyses to ensure they meet industrial application requirements.
---3.Track and research the application of materials in various research institutions and enterprises.
---4.Proficiently operate various testing and characterization equipment.
---5.Responsible for the characterization and optimization of high-temperature superconducting materials' performance.
---Qualifications:
---1.Background in physics, chemistry, materials science, electrical engineering, with preference for electrical engineering.
---2.Strong hands-on skills; experience in superconducting materials is preferred.
---3.Strong observational and analytical skills, familiar with various testing equipment and data processing software.
---4.Responsible, meticulous, with good teamwork and communication skills.`,
      },
//       postProcessor: {
//         title: "后处理技术员",
//         details: `岗位职责：
// ---1.负责带材分切或封装的生产任务及设备日常保养；
// ---2.负责包裹带及银带的点检及记录工作；
// ---3.及时上报生产过程异常，并能发现问题和解决问题；
// ---4.协助主管领导进行带材后处理过程中的统计工作。
// ---任职要求：
// ---1.全日制大专及以上学历；
// ---2.拥有较高的思想觉悟，过硬的综合身体素质；
// ---3.拥有严谨的工作态度，有良好的团队意识和沟通能力，能承受一定的工作压力；
// ---4.能吃苦耐劳，接受加班工作。`,
//       },
//       inspector: {
//         title: "质检员",
//         details: `岗位职责：
// ---1.负责AFM、XRD、台阶仪、光学显微镜等表征设备
// ---2.负责超导带材临界电流测试、电阻、应力测试等带材性能表征设备
// ---3.负责货品入厂、出厂检测、不合格品处理等ISO体系中的质检任务
// ---4.负责一定的检测、应用设备维护工作

// ---任职要求：
// ---1.物理、化学、材料、电气、电子、自动化等相关专业
// ---2.动手能力强，有质量管理经验者优先考虑
// ---3.具有较强的观察能力和分析能力，熟悉各类测试设备和数据处理软件
// ---4.工作认真负责、严谨细致、有良好的团队意识和沟通能力`,
//       },
//       processEngineer: {
//         title: "工艺工程师",
//         details: `岗位职责：
// ---1.负责定制本工艺段的工艺调试计划，生产过程中出现的异常问题解决，及时制定解决办法；
// ---2.对产品结果跟进，核对生产工艺，对生产现场进行检查，确认生产过程无误；
// ---3.能够积极阅读文章，整理文献内容，对现有工艺进行优化升级；
// ---4.制定工艺文件，新项目引入工作跟进等。
// ---任职要求：
// ---1.硕士及以上学历，理工科背景；
// ---2.2年以上工作经验；
// ---3、较高的思想觉悟，过硬的综合身体素质，服从领导安排；
// ---4、工作态度诚恳，可以认真学习新的知识；
// ---5、可以接受加班；
// ---6、有相关真空镀膜工作经验的人员优先。`,
//       },
//       qualityEngineer: {
//         title: "质量工程师",
//         details: `岗位职责：
// ---1、负责现场检验产品质量情况；
// ---2、负责生产过程中的产品缺陷及质量问题总结归纳；
// ---3、安排并设计相应的实验工作，印证质量问题，并寻找解决方案；
// ---4、对已有产品相关性能指标进行提炼，制定产品质量规范；
// ---5、配合完成质量体系相关工作，完成年度计划月度计划等公司内部文件撰写；
// ---6、完成国家标准比对测试、专利撰写、国内项目相关技术文件撰写等工作。
// ---任职要求：
// ---1、研究生及以上学历，机械、电器、材料等相关工科专业；
// ---2、3年以上相关工作经验；
// ---3、具有独立解决问题的能力，愿意努力学习新事物并拓展自己的知识面；
// ---4、工作认真负责，有良好的团队意识和沟通能力；
// ---5、有国家项目申报与结题经验者，有质量体系工作经验者优先。`,
//       },
//       mechanicalDesigner: {
//         title: "机械设计工程师",
//         details: `岗位职责：
// ---1.测绘原有设备结构；
// ---2.根据生产要求设计新生产的设备，并装配调试；
// ---3.对现有设备进行技术改造；
// ---4.设计超导应用相关工装与结构。
// ---任职要求：
// ---1.熟练使用Solidworks、CAD等机械制图软件；
// ---2.具备一定程度的材料应用、热处理、表面处理及公差配合理论基础；
// ---3.有独立设计大型机械设备的经验，能将设计的三位模型转化为委外加工图纸及出BOOM表；
// ---4.工作认真负责，严谨细致，有良好的团队意识和沟通能力；
// ---5.有真空镀膜腔体或卷对卷设备设计经验者优先考虑。`,
//       },
      rdEngineer: {
        title: "Research and Development Engineer (R&D Position)",
        details: `Job Responsibilities:
---1.Design and implement specific experimental plans according to the R&D department's schedule.
---2.Analyze and resolve process anomalies in the vacuum coating production line (cleanroom) and implement solutions.
---3.Develop new process technologies and materials to enhance the performance and yield of superconducting tape (wire) products.
---4.Collaborate with colleagues to advance related R&D projects.
---5.Complete other R&D tasks assigned by leadership.
---Qualifications:
---1.Master's degree or above, preferably in materials science, physics, or related fields.
---2. Experience in superconducting materials research, thin-film material preparation, or vacuum coating is preferred.
---3. Long-term commitment, passion for R&D work, and the ability to follow the department's R&D plan.
---4. Strong work ethic, initiative, and excellent professional and dedication spirit.`,
      },
//       electricalEngineer: {
//         title: "电气工程师",
//         details: `岗位职责：
// ---1、电气图纸设计；
// ---2、根据公司标准化进行电气硬件选型；
// ---3、跟进施工现场电气施工情况；
// ---4、现场安装调试电气设备，分析处理现场故障；
// ---5、PLC程序的编写与调试；
// ---6、负责共享文件之电气类资料的建立更新维护和备份；
// ---7、协助各专业及部门的各类验证工作；
// ---8、完成上级领导安排的其他工作。
// ---任职要求：
// ---1、全日制本科及以上学历，电气自动化相关专业；
// ---2、5年以上工业自动化、电气自动化线路设计和电子生产工艺经验；
// ---3、熟悉AutoCAD等电气设计相关的软件，精通PLC编程（三菱、西门子等）、熟练labview软件，熟悉各种人机界面设计；
// ---4、能独立承担电气项目的设计及调试工作；
// ---5、服从上级领导的安排，工作认真负责；
// ---6、具有良好的团队精神和较强的协调能力，良好的沟通能力。`,
//       },
//       purchasingEngineer: {
//         title: "采购工程师",
//         details: `岗位职责：
// ---1、负责机械加工件采购；
// ---2、负责机械加工成本分析，降低采购成本；
// ---3、开展供应商渠道开拓；
// ---4、做好采购物资质量问题中的各种影响因素及主要原因的分析；
// ---5、协助开展市场信息收集和研究；
// ---6、建立及维护优质供应商关系；
// ---7、做好供应商往来的跟单、建账和统计分析。
// ---任职要求：
// ---1、全日制大专及以上学历，采购专业、机械设计、数控机械加工专业为佳；
// ---2、机械加工及芯片行业企业任职经验优先；
// ---3、5-10年采购工作经验，5年以上机械加工件采购工作经验；
// ---4、具有较强的沟通协作能力、丰富的谈判技巧，熟练掌握经济法尤其是合同法等相关法律知识；
// ---5、熟练使用各类办公软件，包括ERP系统及OA办公自动化系统。`,
//       },
    },
  },
  info:{
    title: "Contact Information",
    accordionTitle: "Contact Information",
    menuTitle: "Contact Information",
    content: `Address: 781 Kangwei Road, Pudong New District, Shanghai
    ---Phone: (Main) 021-50817399 (Sales) 021-64056173
    ---Email:
    ---(Sales) sales{'@'}shsctec.com ---(Recruitment) hr{'@'}shsctec.com ---(Inquiry) inquiry{'@'}shsctec.com ---(Anti-commercial bribery) inspection{'@'}shsctec.com`
  }
};
